export var TOGGLE_UPDATE_LG_POST = 'TOGGLE_UPDATE_LG_POST';
export function toggleLongReadPostUpdate(postid, updateStatus, lgId) {
    return function (dispatch) {
        dispatch({
            type: TOGGLE_UPDATE_LG_POST,
            payload: {
                lgId: lgId,
                data: { id: postid, updateStatus: updateStatus }
            }
        });
    };
}
//# sourceMappingURL=toggleLRPostUpdate.js.mapexport var TOGGLE_UPDATE_LG_POST = 'TOGGLE_UPDATE_LG_POST';
export function toggleLongReadPostUpdate(postid, updateStatus, lgId) {
    return function (dispatch) {
        dispatch({
            type: TOGGLE_UPDATE_LG_POST,
            payload: {
                lgId: lgId,
                data: { id: postid, updateStatus: updateStatus }
            }
        });
    };
}
//# sourceMappingURL=toggleLRPostUpdate.js.map